module.exports = __webpack_public_path__ + "static/media/info.7ac1daee.svg";